<template>
    <div class="common-problem">
        <div class="problem-content">
            <div class="header clearfix">
                <div class="left">
                    常见问题
                </div>
                <div class="right" @click="problemClose()">
                    <i class="iconfont icon-guanbi"></i>
                </div>
            </div>
            <div class="problem-list">
                <el-scrollbar style="width: 100%;height: 100%;">
                    <ul>
                        <li v-for="(item, index) in problemList" :key="'problemList' + index">
                            <div class="problem-title clearfix">
                                <div class="index left" v-html="index+ 1"></div>
                                <div class="title left" v-html="item.content"></div>
                            </div>
                            <div class="answer clearfix">
                                <div class="title left">答：</div>
                                <div class="answer-content left">
                                    <span v-html="item.replycontent"></span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </el-scrollbar>
            </div>
        </div>
    </div>
</template>
<script>
import {mapResourceApi} from '@/api/mapResourceApi'
export default {
  data() {
    return {
      problemList: []
    }
  },
  methods: {
    getData() {
      const _this = this
      const params = {
        pageNo: 0,
        pageSize: 0,
        params: [
          {
            column: '',
            type: '',
            val: ''
          }
        ]
      }
      mapResourceApi.getProblemList(params).then(response => {
        if (response.code === '200') {
          _this.problemList = []
          const list = response.data.list
          if (list.length && list.length > 0) {
            for (let j = 0; j < list.length; j++) {
              if (list[j].type != 0) {
                _this.problemList.push(list[j])
              }
            }
          } else {
            _this.problemList = list
          }
        } else {
          Notification.warning({
            title: '警告',
            message: '获取数据出错!',
            type: 'warning'
          })
          _this.problemList = []
        }
      })
    },
    // 关闭常见问题
    problemClose() {
      this.$parent.commonProblemShow = false
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getData()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // this.getData()
  }
}
</script>
<style lang="scss" scoped>
    .common-problem{
        position: fixed;
        width: 100%;
        background: rgba(0,0,0,0.5);
        top: 60px;
        left: 0px;
        height: calc(100% - 60px);
        z-index: 999;
        .problem-content{
            position: absolute;
            top: 50%;
            left: 50%;
            width: 850px;
            height: calc(100% - 200px);
            transform: translate(-50%, -50%);
            background: #fff;
            border-radius: 4px;
            .header{
                height: 44px;
                font-size: 16px;
                font-weight: bold;
                line-height: 44px;
                color: #000000;
                padding: 0px 20px;
                i.iconfont{
                    cursor: pointer;
                }
            }
            .problem-list{
                height: calc(100% - 44px);
                width: 100%;
                ul{
                    padding: 20px;
                    li{
                        border: 1px solid #efefef;
                        border-radius: 4px;
                        width: 100%;
                        margin-bottom: 15px;
                        .problem-title{
                            background: #fafafa;
                            font-size: 16px;
                            font-weight: bold;
                            color: #333333;
                            line-height: 24px;
                            border-bottom: 1px solid #efefef;
                            padding: 15px 20px;
                            .title{
                                width: calc(100% - 35px);
                                text-align: left;
                            }
                            .index{
                                width: 24px;
                                height: 24px;
                                background: #edecec;
                                text-align: center;
                                margin-right: 10px;
                            }
                        }
                        .answer{
                            padding: 15px 20px;
                            font-size: 16px;
                            color: #999999;
                            line-height: 25px;
                            .answer-content{
                                font-weight: bold;
                                color: #333333;
                                width: calc(100% - 32px);
                                text-align: left;
                            }
                        }
                        &:last-child{
                             margin-bottom: 0px;
                         }
                    }
                }
                ::v-deep{
                    .el-scrollbar__wrap{
                        overflow-x: hidden;
                    }
                }
            }
        }
    }
</style>
